import type { Response } from 'api/apiBase';
import { axiosToken } from 'api/apiBase/axios';
import { mapError } from 'api/apiBase/mapError';
import { mapResponse } from 'api/apiBase/mapResponse';

import type {
  DexNativeQuote,
  DexSwapCreateRequest,
  DexSwapPreview,
  DexSwapRequest,
  DexSwapTaskDetails,
  DexSwapTaskList,
} from './types';

const baseUrl = (pairId: number) => `/api/pairs/${pairId}/swap-tasks`;

export const previewDexSwapTask = async (
  pairId: number,
  body: DexSwapRequest,
): Promise<Response<DexSwapPreview>> => {
  try {
    const response = await axiosToken.post(`${baseUrl(pairId)}/preview`, body);
    return mapResponse({ data: response.data });
  } catch (error) {
    return mapError({ error });
  }
};

export const createDexSwapTask = async (
  pairId: number,
  body: DexSwapCreateRequest,
): Promise<Response<DexSwapTaskDetails>> => {
  try {
    const response = await axiosToken.post(baseUrl(pairId), body);
    return mapResponse({ data: response.data });
  } catch (error) {
    return mapError({ error });
  }
};

export const getDexSwapTasks = async (pairId: number): Promise<Response<DexSwapTaskList>> => {
  try {
    const response = await axiosToken.get(baseUrl(pairId));
    return mapResponse({ data: response.data });
  } catch (error) {
    return mapError({ error });
  }
};

export const getDexSwapTask = async (
  pairId: number,
  taskId: number,
): Promise<Response<DexSwapTaskDetails>> => {
  try {
    const response = await axiosToken.get(`${baseUrl(pairId)}/${taskId}`);
    return mapResponse({ data: response.data });
  } catch (error) {
    return mapError({ error });
  }
};

export const getDexNativeQuote = async (pairId: number): Promise<Response<DexNativeQuote>> => {
  try {
    const response = await axiosToken.get(`${baseUrl(pairId)}/native-quote`);
    return mapResponse({ data: response.data });
  } catch (error) {
    return mapError({ error });
  }
};
